import { computed } from 'vue'

export const DOMAIN_META = {
  sequencing: { label: 'sequencing', iconClasses: ['fa', 'fa-dna'] },
  light_microscopy: {
    label: 'light microscopy',
    iconClasses: ['fa', 'fa-microscope'],
  },
  electron_microscopy: {
    label: 'electron microscopy',
    iconClasses: ['fa', 'fa-atom'],
  },
  proteomics: { label: 'proteomics', iconClasses: ['fa', 'fa-cubes'] },
  metabolomics: { label: 'metabolomics', iconClasses: ['fa', 'fa-flask'] },
  xray: { label: 'x-ray', iconClasses: ['fa', 'fa-x-ray'] },
  other: { label: 'other', iconClasses: ['fa', 'fa-vial'] },
}

export const DOMAIN_ORDER = Object.keys(DOMAIN_META)

/**
 * Groups assay items by domain with auto-discovery for unknown domains.
 *
 * @param {import('vue').Ref | import('vue').ComputedRef} assayItemsRef
 *   A ref/computed whose .value is an array of objects with a `domain` field.
 */
export function useAssayDomains(assayItemsRef) {
  const domainCategories = computed(() => {
    const items = assayItemsRef.value || []
    const discovered = new Set(
      items.map((a) => String(a.domain || 'other').toLowerCase()),
    )
    const result = {}
    for (const key of DOMAIN_ORDER) {
      if (discovered.has(key)) {
        result[key] = DOMAIN_META[key]
      }
    }
    for (const key of discovered) {
      if (!result[key]) {
        result[key] = { label: key, iconClasses: ['fa', 'fa-circle'] }
      }
    }
    return result
  })

  const assaysPerDomain = computed(() => {
    const items = assayItemsRef.value || []
    return Object.keys(domainCategories.value).reduce((acc, key) => {
      acc[key] = items.filter(
        (a) => String(a.domain || 'other').toLowerCase() === key,
      )
      return acc
    }, {})
  })

  const visibleDomainKeys = computed(() =>
    Object.keys(domainCategories.value).filter(
      (k) => assaysPerDomain.value[k]?.length > 0,
    ),
  )

  return { domainCategories, assaysPerDomain, visibleDomainKeys }
}
